import { FormikProvider, useFormik } from 'formik';
import { useEffect } from 'react';

import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import NonFieldErrors from '@perpay-web/components/base/NonFieldErrors/NonFieldErrors';
import FormikTextInput from '@perpay-web/components/base/TextInput/FormikTextInput';
import LegacyFocusLayout from '@perpay-web/components/composite/LegacyFocusLayout/LegacyFocusLayout';
import { formatMaskedPhoneNumber } from '@perpay-web/utils/stringUtils';
import { phoneVerification } from '@perpay-web/validators/formBased';

import styles from './UserVerificationModal.scss';

const VerifyPhoneNumberStep = ({
    initialValues = {
        code: '',
    },
    verifyPhoneNumber,
    mobilePhone,
    onResend,
    loading,
    errors,
    onHelpButtonClick,
    onLoadPageView,
}) => {
    useEffect(() => {
        if (onLoadPageView) {
            onLoadPageView();
        }
    }, [onLoadPageView]);

    const formik = useFormik({
        initialValues,
        onSubmit: (values) => {
            const valuesToSubmit = {
                ...values,
                tcpaOptIn:
                    typeof values.tcpaOptIn !== 'undefined'
                        ? values.tcpaOptIn
                        : false,
            };
            verifyPhoneNumber(valuesToSubmit);
        },
        validate: phoneVerification,
    });

    return (
        <div className={styles['modal-content']}>
            <FormikProvider value={formik}>
                <form onSubmit={formik.handleSubmit}>
                    <LegacyFocusLayout
                        contentClassName={styles['form-focus-layout']}
                        footerClassName={styles['modal-footer']}
                        footer={
                            <>
                                <CustomButton
                                    Component={CustomButton}
                                    loading={loading}
                                    type='submit'
                                    className={styles.button}
                                >
                                    Verify
                                </CustomButton>
                                <CustomButton
                                    action='link'
                                    type='button'
                                    className={styles['button-link']}
                                    onClick={onHelpButtonClick}
                                >
                                    Get help
                                </CustomButton>
                            </>
                        }
                    >
                        <div>
                            <div className={styles['step-subtitle']}>
                                Final Step
                            </div>
                            <div className={styles.description}>
                                <div className={styles.title}>
                                    Verify your phone number
                                </div>
                                <div className={styles.subtitle}>
                                    We sent a code to&nbsp;
                                    <span>
                                        {formatMaskedPhoneNumber(mobilePhone)}
                                    </span>
                                    .
                                </div>
                            </div>
                            <FormikTextInput
                                className={styles['verification-code-input']}
                                label='Verification code'
                                name='code'
                                type='tel'
                                maxLength='4'
                            />
                            <CustomButton
                                action='inline-link'
                                onClick={onResend}
                            >
                                Resend code
                            </CustomButton>
                            <NonFieldErrors
                                errors={errors}
                                className={styles.error}
                            />
                        </div>
                    </LegacyFocusLayout>
                </form>
            </FormikProvider>
        </div>
    );
};

export default VerifyPhoneNumberStep;
